import { Component, OnInit } from "@angular/core";
import { Produit } from "../models/Produit.model";
import { Categorie } from "../models/Categorie.model";
import { ProduitService } from "../_services/Produit.service";
import { CategorieService } from "../_services/Categorie.service";
import Swal from "sweetalert2";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: "app-produit",
  templateUrl: "./produit.component.html",
  styleUrls: ["./produit.component.css"],
})
export class ProduitComponent implements OnInit {
  p: number = 1;
  produits: Produit[];
  categories: Categorie[];
  productEmpty = "assets/img/avatars/empty-img.png";
  constructor(
    private produitservice: ProduitService,
    private categorieservice: CategorieService,
    public sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.LoadTable();
    this.getAllCategories();
    ///////
    var pageHeader = $(".content-header").find("b");
    var adminForm = $(".admin-form");
    var buttons = adminForm.find(".button");
    var Panel = adminForm.find(".panel");
    setTimeout(function () {
      adminForm.addClass("theme-success");
      Panel.addClass("panel-success");
      pageHeader.addClass("text-success");

      buttons.removeClass().addClass("button btn-success");
    }, 800);
    //////
  }
  LoadTable() {
    this.spinner.show();
    this.produitservice.getData().subscribe((data: Produit[]) => {
      this.produits = data;
      console.log(this.produits);
      for (let a of this.produits) {
        a.image = a.images.filter((b) => b.def == true)[0].image;
      }
      this.spinner.hide();
    });
  }
  delete(id) {
    this.produitservice.deleteData(id).subscribe(() => {
      this.LoadTable();
    });
  }
  getAllCategories() {
    this.categorieservice.getData().subscribe((data: Categorie[]) => {
      this.categories = data;
      console.log(this.categories);
    });
  }
  deleteSupprimer(id) {
    Swal.fire({
      title: "Etes-vous sûre de vouloir supprimer?",
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.delete(id);
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
    /* Swal.fire({
       title: 'Êtes-vous sûr de vouloir supprimer.',
       text: "A revoir ...",
       type: 'warning',
       showCancelButton: true,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
       confirmButtonText: 'Yes, delete it!'
     }).then((result) => {
       if (result.value) {
         this.delete(id);
         Swal.fire(
           'Supprimé!',
           'Supprimé avec succès',
           'success'
         )
       }else {

       }
     })*/
  }
}
